import React from 'react';

export const DrawerContext = React.createContext();
DrawerContext.displayName = 'Drawer context provider';

export const DrawerProvider = DrawerContext.Provider;
